import type { ApplyMessagingMessageDetailUpdateParams } from '../../types/cache/messages-update.types';
import { type Message, MessageStatus } from 'src/api/generated';

/**
 * Applies a message snapshot to the exact message-detail cache.
 *
 * @param params - Cache update inputs including the query client and message id.
 */
export const applyMessagingMessageDetailUpdate = ({
  queryClient,
  messageId,
  action,
  message,
}: ApplyMessagingMessageDetailUpdateParams): void => {
  queryClient.setQueryData<Message | null>(
    ['messaging/messages', messageId],
    (oldMessage) => {
      if (!oldMessage) {
        return oldMessage;
      }

      if (action === 'deleted') {
        return {
          ...oldMessage,
          ...message,
          status: MessageStatus.DELETED,
        };
      }

      if (!message) {
        return oldMessage;
      }

      return { ...oldMessage, ...message };
    }
  );
};
